import { render, staticRenderFns } from "./campaigns-weekly-view-header.vue?vue&type=template&id=3d9c9874&scoped=true"
import script from "./campaigns-weekly-view-header.vue?vue&type=script&lang=js"
export * from "./campaigns-weekly-view-header.vue?vue&type=script&lang=js"
import style0 from "./campaigns-weekly-view-header.vue?vue&type=style&index=0&id=3d9c9874&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d9c9874",
  null
  
)

export default component.exports